
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4c2.25 0 3.764.886 5.125 1.625S23.731 7 26 7h1v1c0 7.745-2.608 12.78-5.25 15.813s-5.375 4.125-5.375 4.125l-.375.125-.375-.125s-2.734-1.118-5.375-4.156S5 15.719 5 8.001v-1h1c2.282 0 3.517-.637 4.875-1.375S13.75 4.001 16 4.001zm0 2c-1.75 0-2.755.613-4.156 1.375a12.508 12.508 0 01-4.781 1.469c.192 6.736 2.429 11.027 4.688 13.625 2.046 2.354 3.763 3.156 4.25 3.375.486-.217 2.205-.997 4.25-3.344 2.258-2.591 4.497-6.892 4.688-13.656a12.531 12.531 0 01-4.781-1.469C18.755 6.614 17.752 6 16.002 6z"}})])
          )
        }
      }
    